import { useEffect, useState } from 'react';

export interface SyncConnector {
    connector_id: number;
    company_name: string;
    company_code: string | null;
}

interface UseSyncConnectorsResult {
    connectors: SyncConnector[];
    loading: boolean;
    error: string | null;
}

function authHeaders(): HeadersInit {
    const token = localStorage.getItem('auth_token');
    return {
        Accept: 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
}

export function useSyncConnectors(enabled: boolean = true): UseSyncConnectorsResult {
    const [connectors, setConnectors] = useState<SyncConnector[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!enabled) return;

        const controller = new AbortController();
        setLoading(true);
        setError(null);

        fetch('/api/sync-connectors', { headers: authHeaders(), signal: controller.signal })
            .then((res) => {
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                return res.json();
            })
            .then((json: SyncConnector[]) => {
                setConnectors(json);
                setLoading(false);
            })
            .catch((err) => {
                if (err.name !== 'AbortError') {
                    setError(err.message);
                    setLoading(false);
                }
            });

        return () => controller.abort();
    }, [enabled]);

    return { connectors, loading, error };
}
